function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-NeuLaden"
}, /*#__PURE__*/React.createElement("rect", {
  width: 29,
  height: 28
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "NeuLaden",
  clipPath: "url(#clip-NeuLaden)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Gruppe_8",
  "data-name": "Gruppe 8"
}, /*#__PURE__*/React.createElement("g", {
  id: "Rechteck_9",
  "data-name": "Rechteck 9",
  transform: "translate(3 2)",
  fill: "#e6e2e6",
  stroke: "#c6c6c6",
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  rx: 2,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23,
  height: 23,
  rx: 1.5,
  fill: "none"
})), /*#__PURE__*/React.createElement("path", {
  id: "ic_refresh_24px",
  d: "M12.021,5.38a4.7,4.7,0,1,0,1.222,4.493H12.021A3.522,3.522,0,1,1,8.7,5.175,3.474,3.474,0,0,1,11.181,6.22L9.29,8.111H13.4V4Z",
  transform: "translate(5.99 5)"
})));

var SvgReloadKey = function SvgReloadKey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReloadKey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reload-key.79e6d510.svg";
export { ForwardRef as ReactComponent };